"use strict";
import React from "react";
import ReactDOM from "react-dom";
import EmailForwarderWrapper from "../email_forwarder_wrapper";
const FACTOR_INVOICE_ID_ATTR = "factor-invoice-id";
const EMAIL_ID_ATTR = "email-id";
const TAG = "ht-email-forwarder";
class EmailForwarderElement extends HTMLElement {
  static get observedAttributes() {
    return [FACTOR_INVOICE_ID_ATTR, EMAIL_ID_ATTR];
  }
  connectedCallback() {
    this.renderFromAttributes();
  }
  attributeChangedCallback(name) {
    if (name === FACTOR_INVOICE_ID_ATTR || name === EMAIL_ID_ATTR) {
      this.renderFromAttributes();
    }
  }
  disconnectedCallback() {
    ReactDOM.unmountComponentAtNode(this);
  }
  renderFromAttributes() {
    const factorInvoiceId = this.getAttribute(FACTOR_INVOICE_ID_ATTR);
    if (!factorInvoiceId) return;
    const emailId = this.getAttribute(EMAIL_ID_ATTR);
    ReactDOM.render(
      React.createElement(EmailForwarderWrapper, {
        factorInvoiceId: parseInt(factorInvoiceId, 10),
        emailId: emailId ? parseInt(emailId, 10) : void 0,
        onDone: (completed) => {
          this.dispatchEvent(
            new CustomEvent("forward-done", {
              bubbles: true,
              detail: completed
            })
          );
        },
        onCancel: () => {
          this.dispatchEvent(
            new CustomEvent("forward-cancelled", { bubbles: true })
          );
        }
      }),
      this
    );
  }
}
if (!customElements.get(TAG)) {
  customElements.define(TAG, EmailForwarderElement);
}
